import { batchremoveexception, batchreview, deletereviewConfig, diff, 
  exception, getbarcode, getbycarrier, getreviewConfig, modify, offline, 
  online, page, queryexception, queryFull, queryprinturl, removeexception, 
  review, reviewBatch, reviewblack, reviewConfig, verify, verifycontainer, 
  verifypick, weighing, savePromptTone, getPromptToneByDc, getTemp} from '@/services/forward/out/CheckPlate';
import { formatMessage } from 'umi/locale';

export default {
  namespace: 'checkplate',
  subscriptions: {
    /**
     * 监听浏览器地址
     * @param dispatch 触发器，用于触发 effects 中的 query 方法
     * @param history 浏览器历史记录，主要用到它的 location 属性以获取地址栏地址
     */
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location.payload && location.pathname == "/out/checkPlate") {
          dispatch({
            type: 'showPage',
            payload: location.payload,
          })
        }
      });
    }
  },
  state: {
    showPage: 'query',
    changePage: 'pack',
    printData: {},
    data: {
      list: [],
      pagination: {}
    },
    checkplateConfig: {}
  },
  effects: {
    *reviewConfig({ payload, callback }, { call, put }) {
      const response = yield call(reviewConfig, payload);
      if (callback) callback(response);
    },
    *getreviewConfig({ payload, callback }, { call, put }) {
      const response = yield call(getreviewConfig, payload);
      if (callback) callback(response);
    },
    *deletereviewConfig({ payload, callback }, { call, put }) {
      const response = yield call(deletereviewConfig, payload);
      if (callback) callback(response);
    },
    *modify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (callback) callback(response);
    },
    *offline({ payload, callback }, { call, put }) {
      const response = yield call(offline, payload);
      if (callback) callback(response);
    },
    *online({ payload, callback }, { call, put }) {
      const response = yield call(online, payload);
      if (callback) callback(response);
    },
    *page({ payload, callback }, { call, put }) {
      const response = yield call(page, payload);
      if (response && response.success) {
        yield put({
          type: 'save',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },
    *verifycontainer({ payload, callback }, { call, put }) {
      const response = yield call(verifycontainer, payload);
      if (callback) callback(response);
    },
    *review({ payload, callback }, { call, put }) {
      const response = yield call(review, payload);
      if (callback) callback(response);
    },
    *weighing({ payload, callback }, { call, put }) {
      const response = yield call(weighing, payload);
      if (callback) callback(response);
    },
    *queryexception({ payload, callback }, { call, put }) {
      const response = yield call(queryexception, payload);
      if (callback) callback(response);
    },
    *removeexception({ payload, callback }, { call, put }) {
      const response = yield call(removeexception, payload);
      if (callback) callback(response);
    },
    *exception({ payload, callback }, { call, put }) {
      const response = yield call(exception, payload);
      if (callback) callback(response);
    },
    *getTemp({ payload, callback }, { call, put }) {
      const response = yield call(getTemp, payload);
      if (callback) callback(response);
    },
    *showPage({ payload }, { call, put }) {
      yield put({
        type: 'onShowPage',
        showPage: payload.showPage,
        entityUuid: payload.entityUuid
      });
    },
    *changePage({ payload }, { call, put }) {
      yield put({
        type: 'onChangePage',
        changePage: payload.changePage,
        printData: payload.printData
      });
    },
    *verify({ payload, callback }, { call, put }) {
      const response = yield call(verify, payload);
      if (callback) callback(response);
    },
    *verifypick({ payload, callback }, { call, put }) {
      const response = yield call(verifypick, payload);
      if (callback) callback(response);
    },
    *reviewblack({ payload, callback }, { call, put }) {
      const response = yield call(reviewblack, payload);
      if (callback) callback(response);
    },
    *getbarcode({ payload, callback }, { call, put }) {
      const response = yield call(getbarcode, payload);
      if (callback) callback(response);
    },
    *queryFull({ payload, callback }, { call, put }) {
      const response = yield call(queryFull, payload);
      if (callback) callback(response);
    },
    *diff({ payload, callback }, { call, put }) {
      const response = yield call(diff, payload);
      if (callback) callback(response);
    },
    *queryprinturl({ payload, callback }, { call, put }) {
      const response = yield call(queryprinturl, payload);
      if (callback) callback(response);
    },
    *batchreview({ payload, callback }, { call, put }) {
      const response = yield call(batchreview, payload);
      if (callback) callback(response);
    },
    *batchremoveexception({ payload, callback }, { call, put }) {
      const response = yield call(batchremoveexception, payload);
      if (callback) callback(response);
    },
    *getbycarrier({ payload, callback }, { call, put }) {
      const response = yield call(getbycarrier, payload);
      if (callback) callback(response);
    },
    *reviewBatch({ payload, callback }, { call, put }) {
      const response = yield call(reviewBatch, payload);
      if (callback) callback(response);
    },
    *changeCheckplate({ payload, callback }, { call, put }) {
      yield put({
        type: 'onChangeConfig',
        checkplateConfig: payload.data,
      });
    },
    *savePromptTone({ payload, callback }, { call, put }) {
      const response = yield call(savePromptTone, payload);
      if (callback) callback(response);
    },
    *getPromptToneByDc({ payload, callback }, { call, put }) {
      const response = yield call(getPromptToneByDc, payload);
      if (callback) callback(response);
    }
  },
  reducers: {
    onShowPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        entityUuid: action.entityUuid
      }
    },
    onChangePage(state, action) {
      return {
        ...state,
        changePage: action.changePage,
        printData: action.printData
      }
    },
    onChangeConfig(state, action) {
      return {
        ...state,
        checkplateConfig: action.checkplateConfig,
      }
    },
    save(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
  }
}
